<template>
  <div id="login">
    <el-form
      ref="loginFormRef"
      :model="loginForm"
      :rules="loginFormRules"
      id="loginForm"
    >
      <h3>医药医械代表来访报备登记系统</h3>
      <el-form-item prop="username">
        <el-input
          v-model="loginForm.username"
          prefix-icon="el-icon-user"
          placeholder="请输入用户名"
          clearable
        />
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="loginForm.password"
          prefix-icon="el-icon-lock"
          placeholder="请输入密码"
          show-password
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-row>
          <el-col :span="12">
            <el-checkbox v-model="rememberMe">
              记住密码
            </el-checkbox></el-col
          >
          <el-col :span="12">
            <el-button type="text" @click="register">注 册</el-button>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          :loading="$store.state.isLoading"
          @click="login"
        >
          登 录
        </el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="注册"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      width="50%"
    >
      <el-form
        ref="registerFormRef"
        :model="registerForm"
        :rules="registeFormRules"
        label-position="left"
      >
        <el-form-item
          prop="phoneNumber"
          label="手机号(密码忘记请联系12345678912)"
        >
          <el-input
            v-model="registerForm.phoneNumber"
            prefix-icon="el-icon-phone"
            placeholder="请输入手机号"
            clearable
          />
        </el-form-item>

        <el-form-item prop="password" label="密码(改密码为登录密码)">
          <el-input
            v-model="registerForm.password"
            prefix-icon="el-icon-lock"
            placeholder="请输入密码"
            show-password
            clearable
          />
        </el-form-item>

        <el-form-item prop="hospitalName" label="医院名称">
          <el-input
            v-model="registerForm.hospitalName"
            placeholder="请输入医院名称"
            clearable
          />
        </el-form-item>

        <el-form-item prop="contact" label="联系人">
          <el-input
            v-model="registerForm.contact"
            placeholder="请输入联系人"
            clearable
          />
        </el-form-item>

        <el-form-item prop="picUrl" label="医疗机构执业许可证">
          <el-upload
            ref="uploadRef"
            action=""
            list-type="picture-card"
            :http-request="handleHttp"
            :on-remove="handleRemove"
            :file-list="fileList"
            :limit="1"
          >
            <i class="el-icon-plus"></i
          ></el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="registerFormSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { setToken } from "@/common/token";
import { login, registerAdd } from "@/api/main/login";
import { upload } from "@/api/main/file";

export default {
  data() {
    return {
      rememberMe: false,
      dialogVisible: false,
      loginForm: {
        username: "",
        password: "",
      },
      registerForm: {
        phoneNumber: "",
        password: "",
        hospitalName: "",
        contact: "",
        picUrl: "",
      },
      registeFormRules: {
        phoneNumber: [
          {
            required: true,
            message: "用户名不能为空",
            trigger: ["blur", "change"],
          },
        ],
        password: [
          {
            required: true,
            message: "密码不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
      loginFormRules: {
        username: [
          {
            required: true,
            message: "用户名不能为空",
            trigger: ["blur", "change"],
          },
        ],
        password: [
          {
            required: true,
            message: "密码不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
      fileList: [],
      baseUrl: window.g.BASE_URL + "/files/",
    };
  },
  created() {
    const username = Cookies.get(window.g.PROJECT_KEY + "-Username");
    const password = Cookies.get(window.g.PROJECT_KEY + "-Password");
    const rememberMe = Cookies.get(window.g.PROJECT_KEY + "-RememberMe");
    this.loginForm.username = undefined ? "" : username;
    this.loginForm.password = undefined ? "" : password;
    this.rememberMe = undefined ? false : Boolean(rememberMe);
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.$refs.registerFormRef.resetFields();
      this.fileList = [];
    },
    registerFormSubmit() {
      this.registerForm.picUrl = this.fileList
        .map((item) => item.name)
        .join(",");
      this.$refs.registerFormRef.validate(async (valid) => {
        if (valid) {
          await registerAdd(this.registerForm);
        }
        this.dialogVisible = false;
      });
    },
    register() {
      this.dialogVisible = true;
    },
    handleHttp(file) {
      const data = new FormData();
      data.append("file", file.file);
      upload(data).then((res) => {
        this.fileList.push({
          name: res,
          url: this.baseUrl + res,
          uid: file.file.uid,
        });
      });
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    login() {
      this.$refs.loginFormRef.validate((valid) => {
        if (valid) {
          this.$store.commit("isLoading", true);
          login(this.loginForm).then((res) => {
            setToken(res);
            if (this.rememberMe) {
              Cookies.set(
                window.g.PROJECT_KEY + "-Username",
                this.loginForm.username,
                { expires: 30 }
              );
              Cookies.set(
                window.g.PROJECT_KEY + "-Password",
                this.loginForm.password,
                { expires: 30 }
              );
              Cookies.set(
                window.g.PROJECT_KEY + "-RememberMe",
                this.rememberMe,
                { expires: 30 }
              );
            } else {
              Cookies.remove(window.g.PROJECT_KEY + "-Username");
              Cookies.remove(window.g.PROJECT_KEY + "-Password");
              Cookies.remove(window.g.PROJECT_KEY + "-RememberMe");
            }
            this.$router.push("/");
          });
        }
      });
    },
  },
};
</script>

<style>
#login {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("../assets/login-background.jpg");
  background-size: cover;
}
#login #loginForm h3 {
  color: #707070;
  text-align: center;
  margin: 30px 0px 30px 0px;
}
#login #loginForm {
  width: 350px;
  border-radius: 6px;
  background: white;
  padding: 0px 25px 0px 25px;
}
#login #loginForm .el-button {
  width: 100%;
}
</style>
